import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/pmp.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCardPMP from "../components/core/Course/CourseDetailsCardPMP";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = () => {
    // console.log("called", id)
    setIsActive(

    );
  };

  return (
    <>
      <div className={`relative w-full bg-richblue-5`}>
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={image}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>

            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblue-700`}
            >
              <div>
                <p className="text-4xl font-bold text-richblue-700 sm:text-[42px]">
                PMP Training and Certification Course
                </p>
              </div>

              <p className={`text-richblue-500`}>
              With the growing emphasis on effective project management and the need for structured methodologies, the Project Management Professional (PMP) certification has become a gold standard in the industry. This course is meticulously designed to equip professionals with a comprehensive understanding of PMP principles, frameworks, and best practices.<br></br>
              By mastering PMP methodologies, participants can enhance their ability to deliver projects on time, within scope, and under budget, ensuring successful outcomes and stakeholder satisfaction. </p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">5</span>
                <RatingStars Review_Count={5} Star_Size={20} />
                <span>{`(${5} reviews)`}</span>
                <span> | </span>
                <span>{`${200}+ Professionals Enrolled`}</span>
              </div>

              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblue-300 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblue-700">
                Rs. {19999}
              </p>
              <button className="yellowButton">Enroll Now</button>
              <button className="blackButton">Request Free Demo</button>
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCardPMP />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblue-700 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblue-300 p-8">
            <p className="text-3xl font-semibold">Course Overview</p>
            <div className="mt-5">
              <ReactMarkdown>
                {
                  "In today’s fast-paced and competitive business environment, organizations are increasingly relying on skilled project managers to deliver complex projects on time, within budget, and to the highest quality standards. The growing complexity of projects, coupled with the need for effective resource management and risk mitigation, has made it essential for professionals to adopt globally recognized project management practices."
                }
              </ReactMarkdown>
              <ReactMarkdown>
                {
                  "The Project Management Professional (PMP) Certification is designed to address these challenges by equipping professionals with a comprehensive understanding of project management principles, frameworks, and methodologies. This course provides participants with the knowledge and skills to plan, execute, monitor, and close projects successfully. By mastering PMP best practices, professionals can enhance their ability to lead cross-functional teams, manage stakeholder expectations, and deliver projects that align with organizational goals."
                }
              </ReactMarkdown>
            </div>
            <p className="text-3xl font-semibold mt-5">What you'll learn</p>
            <div className="flex flex-col gap-3 mt-5">
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Master core project management principles and PMBOK® Guide standards.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Plan, execute, monitor, and close projects effectively.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Manage project scope, schedule, cost, quality, and risks.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Optimize resource allocation and improve project outcomes.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Prepare confidently for the PMP certification exam.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Mitigate risks and manage changes efficiently.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Deliver projects on time, within budget, and to quality standards.
                </span>
              </p>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Curriculum</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {8} {`module(s)`} &nbsp; |
                  </span>
                  <span>
                    {27} {`lecture(s)`} &nbsp; |
                  </span>
                  <span>{"1h 10m"} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4 ">
              <CourseAccordionBar
                courseName= {"Module 1: Introduction to Project Management"}
                courseList= {[
                  "Purpose of Project Management",
                  "Objectives of the PMP Certification",
                  "The business value of effective project management"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName= {"Module 2: Integration Management"}
                courseList= {[
                  "Develop Project Charter",
                  "Develop Project Management Plan",
                  "Direct and Manage Project Work",
                  "Monitor and Control Project Work",
                  "Perform Integrated Change Control",
                  "Close Project or Phase"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName= {"Module 3: Scope Management"}
                courseList= {[
                  "Plan Scope Management",
                  "Collect Requirements",
                  "Define Scope",
                  "Create Work Breakdown Structure (WBS)",
                  "Validate Scope",
                  "Control Scope"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />{" "}
              <CourseAccordionBar
                courseName= {"Module 4: Time Management"}
                courseList= {[
                  "Plan Schedule Management",
                  "Define Activities",
                  "Sequence Activities",
                  "Estimate Activity Durations",
                  "Develop Schedule",
                  "Control Schedule"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName= {"Module 5: Cost Management"}
                courseList= {[
                  "Plan Cost Management",
                  "Estimate Costs",
                  "Determine Budget",
                  "Control Costs"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName= {"Module 6: Quality Management"}
                courseList= {[
                  "Plan Quality Management",
                  "Manage Quality",
                  "Control Quality"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName= {"Module 7: Human Resource Management"}
                courseList= {[
                  "Plan Resource Management",
                  "Estimate Activity Resources",
                  "Acquire Resources",
                  "Develop Team",
                  "Manage Team",
                  "Control Resources"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName= {"Module 8: Communication Management"}
                courseList= {[
                  "Plan Communication Management",
                  "Manage Communications",
                  "Monitor Communications"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CourseDetails;
